import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import { ExternalButton } from "@sharedComponents/buttons";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
} from "@stadium/ui/src/components/ModalNew/utils";

import styles from "./main.module.scss";

const SizeChartModal = ({ closeModal, data = {} }) => {
  const { sizeChart, productName, sizeChartLink } = data;
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const renderModalBody = () => (
    <>
      <div className={styles.sizeChartHeading}>Size Chart:</div>
      <div className={styles.sizeChartTable}>{ReactHtmlParser(sizeChart)}</div>
    </>
  );

  return (
    <Modal closeModal={closeModal} newModal mobileBottomDrawer>
      <ModalDialog>
        <ModalContent>
          <ModalHeader>
            {productName}
            <CloseButton onClick={closeModal} />
          </ModalHeader>
          <ModalBody className={styles.modalBody}>
            {isMobileDevice ? (
              <BottomIconHideWrapper>{renderModalBody()}</BottomIconHideWrapper>
            ) : (
              renderModalBody()
            )}
            {!!sizeChartLink && (
              <div className={styles.specSheetLinkContainer}>
                <div className={styles.sizeChartHeading}>Product Spec Sheet:</div>
                <ExternalButton
                  href={sizeChartLink}
                  styleType="link"
                  target="_blank"
                  className={styles.specSheetLink}
                >
                  {sizeChartLink}
                </ExternalButton>
              </div>
            )}
          </ModalBody>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default SizeChartModal;
